// Shared between CardRequest.vue (which starts the SlickPay payment) and
// PaymentSuccess.vue (which finishes the card request once payment is
// confirmed). The id photo is round-tripped through localStorage as base64
// because the SATIM redirect leaves the SPA entirely, so a plain File object
// wouldn't survive the trip.

export const PENDING_CARD_REQUEST_KEY = "pendingCardRequest";

// Card type -> fee amount (DA), matching the Platinum/Gold/Classic cards and
// prices shown on the landing page (RequestCart.vue).
export const CARD_PRICES = {
  platinum: 8000,
  gold: 9000,
  classic: 6000,
};

// SlickPay's contact endpoint requires a "rib" (20 numeric digits, unique
// per contact) even though it's meaningless for someone just paying a card
// fee - so a fresh one is generated per submission instead of asking the
// user for a real bank account number.
export function generateRib() {
  let rib = "";
  for (let i = 0; i < 20; i++) {
    rib += Math.floor(Math.random() * 10);
  }
  return rib;
}

export function fileToBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
}

export function base64ToFile(base64, filename) {
  const [header, data] = base64.split(",");
  const mimeMatch = /:(.*?);/.exec(header);
  const mime = mimeMatch ? mimeMatch[1] : "image/jpeg";
  const binary = atob(data);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i++) {
    bytes[i] = binary.charCodeAt(i);
  }
  return new File([bytes], filename, { type: mime });
}
